<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Create Leave</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> Leave created successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="leaveForm" #myForm="ngForm" (ngSubmit)="leaveFormSubmit()">
    <span class="leave-note">Note:<br>
    Casual leave: Need to inform “2” days before <br>
    Sick leave: Can be informed on the same day <br>
    Annual leaves: 5 leaves allowed, need to inform “7” days before <br>
    Optional holidays: only  “2” allowed in an year<br>
    LOP: if leaves are exceeded, applied leaves will be considered as lop
    </span>

        <mat-form-field>
            <mat-label>Leave Type</mat-label>
            <mat-select formControlName="leave_type" (selectionChange)="leaveDays()">
                <mat-option *ngFor="let leaveType of leaveTypes;" [value]="leaveType?.id">
                    <span>{{leaveType?.leave_type}}</span>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="leaveFormValidate?.leave_type?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <div class="side-by-side-mat-form-field">
            <mat-form-field>
                <mat-label>Leave From</mat-label>
                <input matInput formControlName="leave_from" [max]="fromMaxDate" [min]="fromMinDate" (dateInput)="onFromDateChange($event)" [matDatepicker]="leave_from_date" (focus)="leave_from_date.open()">
                <mat-datepicker-toggle matSuffix [for]="leave_from_date"></mat-datepicker-toggle>
                <mat-datepicker #leave_from_date></mat-datepicker>
                <mat-error *ngIf="leaveFormValidate?.leave_from?.errors?.required">This field is required.</mat-error>

            </mat-form-field>

            <mat-form-field>
                <mat-label>Leave To</mat-label>
                <input matInput formControlName="leave_to" [max]="toMaxDate" [min]="toMinDate" (dateInput)="onToDateChange($event)" [matDatepicker]="leave_to_date" (focus)="leave_to_date.open()">
                <mat-datepicker-toggle matSuffix [for]="leave_to_date"></mat-datepicker-toggle>
                <mat-datepicker #leave_to_date></mat-datepicker>
                <mat-error *ngIf="leaveFormValidate?.leave_to?.errors?.required">This field is required.</mat-error>

            </mat-form-field>
        </div>

        <div class="side-by-side-mat-form-field">
            <mat-form-field>
                <mat-label>From Session</mat-label>
                <mat-select formControlName="from_session" (selectionChange)="leaveDays();">
                    <mat-option *ngFor="let leave_session of leave_sessions;" [value]="leave_session?.id">
                        <span>{{leave_session?.session_name}}</span>
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="leaveFormValidate?.from_session?.errors?.required">This field is required.</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>To Session</mat-label>
                <mat-select formControlName="to_session" (selectionChange)="leaveDays();">
                    <mat-option *ngFor="let leave_session of leave_sessions;" [value]="leave_session?.id">
                        <span>{{leave_session?.session_name}}</span>
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="leaveFormValidate?.to_session?.errors?.required">This field is required.</mat-error>
            </mat-form-field>
        </div>
        <div class="side-by-side-mat-form-field">
            <mat-form-field>
                <mat-label> Days</mat-label>
                <input type="text" formControlName="leave_days" matInput>
                <mat-error *ngIf="leaveFormValidate?.leave_days?.errors?.required">This field is required.</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label> Balance</mat-label>
                <input type="text" matInput readonly [value]="availableLeaves">
            </mat-form-field>
        </div>
        <div class="side-by-side-mat-form-field">
            <!-- <mat-form-field *ngIf="isShowUsers">
                <mat-label>User</mat-label>
                <mat-select formControlName="user_id" (selectionChange)="  ($event?.value)">
                    <mat-option *ngFor="let user of users;" [value]="user?.id">
                        <span>{{user?.name}}</span>
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="leaveFormValidate?.user_id?.errors?.required">This field is required.</mat-error>
            </mat-form-field> -->

            <mat-form-field *ngIf="isShowUsers">
                <mat-label>User</mat-label>
                <input type="hidden" formControlName="user_id">
                <input matInput placeholder="Search" [matAutocomplete]="auto" [formControl]="searchUserNameCtrl" [multiple]="true">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchUserName">
                    <mat-option *ngFor="let user of users;" [value]="user">
                        <span>{{user?.name}}</span>
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="leaveFormValidate?.user_id?.errors?.required">This field is required.</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Apply To</mat-label>
                <mat-select formControlName="applied_to">
                    <mat-option *ngFor="let applied_to_user of usersReport;" [value]="applied_to_user?.user_id">
                        <span>{{applied_to_user?.name}}</span>
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="leaveFormValidate?.applied_to?.errors?.required">This field is required.</mat-error>
            </mat-form-field>
        </div>


        <mat-form-field>
            <mat-label>Reason</mat-label>
            <textarea matInput formControlName="leave_reason"></textarea>
        </mat-form-field>


        <div class="footer-block text-center">
            <div class="button-group">
                <button type="submit" mat-raised-button class="btn-int-blue">Create </button>
            </div>
        </div>
    </form>
</div>